// these are all the prefixes needed to use these colors to style buttons and any other
// components that need to have dynamic primary/secondary colors based on the theme
const prefixes = [
    'text-',
    'bg-',
    'border-',
    'hover:bg-',
    'hover:border-',
    'hover:text-',
]

export default function generateColorsSafelist(colors: readonly string[]) {
    return colors
        .map((color) => prefixes.map((prefix) => prefix + color))
        .flat()
}
